import { MainMenuItem } from "@components/atoms";
import {
  Calculator,
  CaretRight,
  ChartBar,
  CheckSquareOffset,
  ClipboardText,
  Files,
  GraduationCap,
  HandCoins,
  Question,
  Table,
  Trophy,
  UsersThree,
} from "@phosphor-icons/react";
import { Tooltip } from "antd";

const SIZE_ICON = 24;
const menuItems = [
  {
    key: "1",
    label: "Clientes",
    icon: <UsersThree size={SIZE_ICON} />,
    href: "/clientes",
  },
  {
    key: "2",
    label: "Cotações",
    icon: <ClipboardText size={SIZE_ICON} />,
    href: "/cotacoes",
  },
  {
    key: "3",
    label: "Índices",
    icon: <Table size={SIZE_ICON} />,
    href: "/indices",
  },
];

const comingSoonItems = [
  {
    key: "4",
    label: "Dashboard",
    icon: <ChartBar size={SIZE_ICON} />,
    href: "#",
  },
  {
    key: "5",
    label: "Pendências",
    icon: <CheckSquareOffset size={SIZE_ICON} />,
    href: "#",
  },
  {
    key: "6",
    label: "Financeiro",
    icon: <Calculator size={SIZE_ICON} />,
    href: "#",
  },
  {
    key: "7",
    label: "Sinistro",
    icon: <HandCoins size={SIZE_ICON} />,
    href: "#",
  },
  {
    key: "8",
    label: "Ranking",
    icon: <Trophy size={SIZE_ICON} />,
    href: "#",
  },
  {
    key: "9",
    label: "Academy",
    icon: <GraduationCap size={SIZE_ICON} />,
    href: "#",
  },
  {
    key: "10",
    label: "Biblioteca",
    icon: <Files size={SIZE_ICON} />,
    href: "#",
  },
];

const WHATSAPP_HELP_URL =
  "https://api.whatsapp.com/send/?phone=5511961905552&text=Ol%C3%A1.+Poderia+me+ajudar+na+%C3%A1rea+logada+da+plataforma+Ruppert%3F&type=phone_number&app_absent=0";

export const MainMenu = ({
  onMenuItemClick,
  collapsed,
}: {
  onMenuItemClick?: () => void;
  collapsed: boolean;
}) => {
  return (
    <div
      className={`flex flex-col gap-1 transition-all ease-in-out duration-300 ${
        collapsed ? "w-16" : "w-64"
      }`}
    >
      {menuItems.map((item) => (
        <Tooltip key={item.key} title={collapsed ? item.label : ""} placement="right">
          <div>
            <MainMenuItem
              href={item.href}
              icon={item.icon}
              onClick={onMenuItemClick}
              collapsed={collapsed}
            >
              {item.label}
            </MainMenuItem>
          </div>
        </Tooltip>
      ))}

      <Tooltip title={collapsed ? "Ajuda" : ""} placement="right">
        <a
          href={WHATSAPP_HELP_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onMenuItemClick}
          className={`group flex items-center gap-3 px-4 py-2 text-base font-light text-white! transition-all! duration-300! hover:bg-white/3! ${
            collapsed ? "justify-center" : ""
          }`}
        >
          <span className="block opacity-50 leading-0 group-hover:text-primary group-hover:opacity-100">
            <Question size={SIZE_ICON} />
          </span>
          {!collapsed && <span className="flex-1">Ajuda</span>}
          {!collapsed && (
            <i className="text-white opacity-0 group-hover:opacity-20 transition-opacity duration-300">
              <CaretRight size={16} />
            </i>
          )}
        </a>
      </Tooltip>

      <hr className="w-full border-t border-white/10 my-4" />

      {!collapsed && <p className="text-white/30 text-xs mb-3">Em breve</p>}
      <div>
        {comingSoonItems.map((item) => (
          <Tooltip key={item.key} title={collapsed ? item.label : ""} placement="right">
            <div
              className={`flex items-center gap-2 px-4 py-2 text-white/30 cursor-not-allowed ${
                collapsed ? "justify-center" : ""
              }`}
            >
              <span>{item.icon}</span>
              {!collapsed && <span>{item.label}</span>}
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};
